import React, { useState } from 'react';
import { Button, Popconfirm, Space, Tag, Typography, Upload } from 'antd';
import { DeleteOutlined, FilePdfOutlined, UploadOutlined } from '@ant-design/icons';
import { mediaUrl } from '../../utils/media';
import { Evidence } from './checklistTypes';

const { Text } = Typography;

interface Props {
  evidence: Evidence[];
  required: boolean;          // a No answer: at least one file is needed
  canEdit: boolean;
  onUpload: (file: File) => Promise<void>;
  onRemove: (evidenceId: string) => void;
}

const EvidenceStrip: React.FC<Props> = ({ evidence, required, canEdit, onUpload, onRemove }) => {
  const [uploading, setUploading] = useState(false);

  const upload = async (file: File) => {
    setUploading(true);
    try { await onUpload(file); } finally { setUploading(false); }
    return false;
  };

  return (
    <div style={{ marginTop: 8 }}>
      <Space wrap align="start">
        <Text type="secondary">Evidence</Text>
        {evidence.length === 0 && required && <Tag color="error">Evidence required</Tag>}
        {evidence.length === 0 && !required && <Text type="secondary">none</Text>}
        {evidence.map((e) => (
          <div key={e.id} style={{ position: 'relative', width: 72 }}>
            <a href={mediaUrl(e.url)} target="_blank" rel="noopener noreferrer" title={e.caption || e.by}>
              {e.type === 'PHOTO' ? (
                <img
                  src={mediaUrl(e.url)} alt="evidence"
                  style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 6, border: '1px solid #f0f0f0' }}
                />
              ) : (
                <div style={{
                  width: 72, height: 72, borderRadius: 6, border: '1px solid #f0f0f0', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', background: '#fafafa',
                }}>
                  <FilePdfOutlined style={{ fontSize: 28, color: '#cf1322' }} />
                </div>
              )}
            </a>
            {canEdit && (
              <Popconfirm title="Remove this file?" okText="Remove" onConfirm={() => onRemove(e.id)}>
                <Button
                  size="small" shape="circle" icon={<DeleteOutlined />}
                  style={{ position: 'absolute', top: -6, right: -6 }}
                />
              </Popconfirm>
            )}
          </div>
        ))}
        {canEdit && (
          <Upload accept=".jpg,.jpeg,.png,.pdf" multiple showUploadList={false} beforeUpload={upload}>
            <Button size="small" icon={<UploadOutlined />} loading={uploading}>Add photo / PDF</Button>
          </Upload>
        )}
      </Space>
    </div>
  );
};

export default EvidenceStrip;
